import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  padding: 40px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 80px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 0;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
`;

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 80px auto;
  padding: 90px 20px 90px 20px;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin: 34px auto 0;
    padding: 0;
    padding-top: 50px;
    padding-bottom: 50px;
    gap: 80px;
  }

  video {
    position: relative;
    z-index: 1;
    padding-left: 80px;
    max-width: 500px;
    height: auto;

    @media (max-width: 768px) {
      max-width: 340px;
      height: auto;
      padding: 0;
    }
  }

  .background-image {
      position: absolute;
      top: 50%;
      left: 30%;
      transform: translate(-50%, -50%);
      z-index: 0;
      width: 25%;
      height: auto;
      max-width: 600px;
      object-fit: contain;
      pointer-events: none;

      @media (max-width: 768px) {
        width: 60%;
        top: 23.5%;
        left: 70%;
      }
    }

    object-fit: cover;
    pointer-events: none; /* permite interações com elementos acima */
  }
`;

export const TextBox1 = styled.div`
  flex: 1;
  padding-left: 133px;
  font-size: 48px;
  font-weight: 200;
  line-height: 56px;
  color: #e4e4e4;

  @media (max-width: 768px) {
    max-width: 340px;
    padding: 0;
  }

  p {
    color: #e4e4e4;
    font-size: 48px;
    font-style: normal;
    font-weight: 200;
    line-height: 56px;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 32px;
      line-height: 32px;
      margin-bottom: 40px;
    }
  }
`;

export const TextBox2 = styled.div`
  flex: 1;
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #c3c3c3;
  text-align: left;

  p {
    font-family: 'Open Sans';
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 16px;
    }
  }

  .link-with-icon {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: #f16024;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    @media (max-width: 768px) {
      max-width: 340px;
      font-size: 16px;
      width: 350px;
      gap: 0;
    }
  }

  .link-with-icon img {
    width: 20px;
    height: 20px;
  }
`;

export const ImageBox = styled.div`
  flex: 1;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;

    @media (max-width: 768px) {
      max-width: 90%;
    }
  }
`;
